<div class="accept-shell">
  @switch (pageState()) {
    @case ('loading') {
      <div class="accept-card accept-card--centered">
        <mat-spinner diameter="32" />
        <p class="accept-card__muted">Checking your invitation…</p>
      </div>
    }

    @case ('invalid') {
      <div class="accept-card accept-card--centered">
        <span class="accept-card__icon accept-card__icon--error">
          <app-icon name="x-circle" [size]="36" />
        </span>
        <h1 class="accept-card__title">Invitation link is invalid</h1>
        <p class="accept-card__muted">
          This link doesn't look right. Ask whoever invited you to send a new one.
        </p>
        <a class="accept-card__link" routerLink="/auth/login">Go to login</a>
      </div>
    }

    @case ('gone') {
      <div class="accept-card accept-card--centered">
        <span class="accept-card__icon accept-card__icon--error">
          <app-icon name="clock" [size]="36" />
        </span>
        <h1 class="accept-card__title">This invitation has expired</h1>
        <p class="accept-card__muted">
          It may have expired, been cancelled, or already been accepted. Ask for a fresh invitation.
        </p>
        <a class="accept-card__link" routerLink="/auth/login">Go to login</a>
      </div>
    }

    @case ('ready') {
      @if (info(); as i) {
        <div class="accept-card">
          <span class="accept-card__icon"><app-icon name="briefcase" [size]="28" /></span>
          <h1 class="accept-card__title">Join {{ i.agency_name }}</h1>
          <p class="accept-card__lead">
            <strong>{{ i.invited_by_name }}</strong> invited <strong>{{ i.email }}</strong> to join
            <strong>{{ i.agency_name }}</strong> as
            {{ i.role === 'ADMIN' ? 'an admin' : 'an agent' }}.
          </p>

          @if (serverError()) {
            <div class="accept-card__error" role="alert" aria-live="assertive">
              {{ serverError() }}
            </div>
          }

          @if (i.is_new_user) {
            <form class="accept-form" [formGroup]="form" novalidate (ngSubmit)="accept()">
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label" for="firstName">
                    First name <span class="required-mark" aria-hidden="true">*</span>
                  </label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput id="firstName" formControlName="firstName" placeholder="Jane" />
                    <mat-error>First name is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="field-group">
                  <label class="field-label" for="lastName">
                    Last name <span class="required-mark" aria-hidden="true">*</span>
                  </label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput id="lastName" formControlName="lastName" placeholder="Smith" />
                    <mat-error>Last name is required</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="field-group">
                <label class="field-label" for="newPassword">
                  Choose a password <span class="required-mark" aria-hidden="true">*</span>
                </label>
                <mat-form-field appearance="outline" class="full-width">
                  <input
                    matInput
                    class="has-password-toggle"
                    id="newPassword"
                    [type]="showPassword() ? 'text' : 'password'"
                    formControlName="newPassword"
                    placeholder="At least 8 characters"
                    autocomplete="new-password"
                  />
                  <button
                    matSuffix
                    mat-icon-button
                    type="button"
                    (click)="togglePassword()"
                    [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                  >
                    <app-icon [name]="showPassword() ? 'x' : 'eye'" [size]="18" />
                  </button>
                  <mat-error>
                    @if (form.controls.newPassword.hasError('required')) {
                      Password is required
                    } @else if (form.controls.newPassword.hasError('minLength')) {
                      Password must be at least 8 characters
                    } @else if (form.controls.newPassword.hasError('noUppercase')) {
                      Add at least one uppercase letter
                    } @else if (form.controls.newPassword.hasError('noNumber')) {
                      Add at least one number
                    } @else if (form.controls.newPassword.hasError('serverError')) {
                      {{ form.controls.newPassword.getError('serverError') }}
                    }
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- AI-assisted assessment consent (POPIA s72) — this accept is the sign-up -->
              <div class="field-group">
                <app-ai-consent-checkbox
                  testId="accept-agency-invitation-ai-consent"
                  [checked]="form.controls.aiConsent.value === true"
                  (changed)="onAiConsentChange($event)"
                />
                @if (form.controls.aiConsent.value !== true) {
                  <p class="field-hint">
                    Optional now — if you leave it unticked, we'll ask before any document is
                    checked.
                  </p>
                }
              </div>

              <button
                mat-flat-button
                type="submit"
                class="full-width"
                [disabled]="isAccepting()"
                [attr.aria-busy]="isAccepting() || null"
                data-testid="accept-agency-invitation-submit"
              >
                @if (isAccepting()) {
                  <mat-spinner diameter="20" aria-hidden="true" />
                  <span>Joining…</span>
                } @else {
                  Accept &amp; join
                }
              </button>
            </form>
          } @else {
            <p class="accept-card__muted">
              You already have a CapX account. Accept to join {{ i.agency_name }}'s team.
            </p>
            <button
              mat-flat-button
              type="button"
              class="full-width"
              (click)="accept()"
              [disabled]="isAccepting()"
              [attr.aria-busy]="isAccepting() || null"
              data-testid="accept-agency-invitation-submit"
            >
              @if (isAccepting()) {
                <mat-spinner diameter="20" aria-hidden="true" />
                <span>Joining…</span>
              } @else {
                Accept &amp; join {{ i.agency_name }}
              }
            </button>
          }
        </div>
      }
    }
  }
</div>
